/* eslint-disable import/extensions */
import cms from './modules/cms/src/index.js';

export default [cms];
